// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"fb7416cb","563":"872c445a","602":"a8a96bc9","675":"d7d0729b","739":"a4c37bbc","760":"de56a4ac","787":"fa1e6a60"}[chunkId] + ".chunk.js";
};